export type ThresholdConfiguration = {
    stateToShow: 'neutral' | 'negative' | 'positive' | 'happy';
    numberOfProgressBarsToColor: 0 | 1 | 2 | 3;
};

export const initSmileyBar = (rootElement: HTMLElement) => {
    if (!rootElement) return;
    const textAreaElement = rootElement.querySelector<HTMLElement>('.js_cr_text-creation__textarea-element');
    if (!textAreaElement) return;
    addEventListener(rootElement, textAreaElement);
};

const addEventListener = (rootElement: HTMLElement, textArea: HTMLElement) => {
    textArea.addEventListener('input', event => handleTyping(rootElement, event));
};

const handleTyping = (rootElement: HTMLElement, event: Event) => {
    if (!event.target) return;
    const textAreaElement = event.target as HTMLTextAreaElement;
    const thresholdConfig = determineThresholdConfig(textAreaElement.value.length);

    colorProgressBars(rootElement, thresholdConfig);
    switchSmiley(rootElement, thresholdConfig);
    switchInfoText(rootElement, thresholdConfig);
};

const neutralThresholdConfig: ThresholdConfiguration = { stateToShow: 'neutral', numberOfProgressBarsToColor: 0 };
const thresholdConfigMap = new Map<number, ThresholdConfiguration>([
    [0, neutralThresholdConfig],
    [50, { stateToShow: 'negative', numberOfProgressBarsToColor: 1 }],
    [82, { stateToShow: 'positive', numberOfProgressBarsToColor: 2 }],
    [Number.MAX_VALUE, { stateToShow: 'happy', numberOfProgressBarsToColor: 3 }],
]);

const determineThresholdConfig = (inputValueLength: number): ThresholdConfiguration => {
    for (const threshold of thresholdConfigMap.keys()) {
        if (inputValueLength <= threshold) {
            return thresholdConfigMap.get(threshold) || neutralThresholdConfig;
        }
    }

    return neutralThresholdConfig;
};

const colorProgressBars = (rootElement: HTMLElement, thresholdConfig: ThresholdConfiguration): void => {
    const progressBarElements = rootElement.querySelectorAll<HTMLElement>('.js_cr_text-creation__smiley-bar__progress > span');

    const progressBarCssPrefix = 'cr_text-creation__smiley-bar__progress';
    progressBarElements.forEach((barElement, index) => {
        barElement.classList.remove(
            `${progressBarCssPrefix}-neutral`,
            `${progressBarCssPrefix}-negative`,
            `${progressBarCssPrefix}-positive`,
            `${progressBarCssPrefix}-happy`
        );
        if (index < thresholdConfig.numberOfProgressBarsToColor) {
            barElement.classList.add(`${progressBarCssPrefix}-${thresholdConfig.stateToShow}`);
        } else {
            barElement.classList.add(`${progressBarCssPrefix}-neutral`);
        }
    });
};

const switchSmiley = (rootElement: HTMLElement, thresholdConfig: ThresholdConfiguration): void => {
    const smileyElements = rootElement.querySelectorAll<HTMLElement>('.cr_text-creation__smiley-bar__smiley');

    smileyElements.forEach(smileyElement => {
        if (smileyElement.className.includes(thresholdConfig.stateToShow)) {
            smileyElement.classList.remove('hidden');
        } else {
            smileyElement.classList.add('hidden');
        }
    });
};

const switchInfoText = (rootElement: HTMLElement, thresholdConfig: ThresholdConfiguration): void => {
    const infoTextElements = rootElement.querySelectorAll<HTMLElement>('.cr_text-creation__smiley-bar__info-text');

    infoTextElements.forEach(infoTextElement => {
        if (infoTextElement.className.includes(thresholdConfig.stateToShow)) {
            infoTextElement.classList.remove('hidden');
        } else {
            infoTextElement.classList.add('hidden');
        }
    });
};
